export default {
    learnMore: 'En savoir plus',
    text: {
        maintenance: 'Nous effectuons actuellement une maintenance.',
        incident: "Nous travaillons sur la résolution d'un problème.",
    },
    affected: 'Service affecté | Services affectés',
};
